import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';

const StyledText = styled.div`
  font-family: Nimbus Sans Light;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.5px;
  color: ${tokens.ColorGrey800};
  padding-top: 32px;
  margin-bottom: 24px;

  @media (max-width: 767px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

class RIGSalaryModal extends Component<any, any> {
  render(): JSX.Element {
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Salary'} showClose={true} />
        <ReactModalContent>
          <StyledText>
            Gross wages from your annual pay, excluding contributions made to non-qualified deferred compensation plans.
            In some situations, you may receive supplemental pay (such as bonuses) in addition to regular wages. In
            these cases, add an estimate of the supplemental pay you expect to receive on a yearly basis (and which you
            anticipate making deferrals on) to your gross wages.
            <br />
            <br />
            If you receive significant supplemental pay that’s not eligible to be contributed to the plan, your
            Retirement Income Goal should be adjusted accordingly.
          </StyledText>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

export default RIGSalaryModal;
